import { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export function ShareButton({ className = "", label = "Share Friendsgiving" }) {
  const [copied, setCopied] = useState(false);
  const url = window.location.origin;
  const share = async () => {
    const data = { title: "Mike & Sam's Friendsgiving", text: "You're invited! Nov 14, 2026 · 2:00 PM EST", url };
    if (navigator.share) {
      try { await navigator.share(data); } catch (_) {}
    } else {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Invite link copied!");
      setTimeout(() => setCopied(false), 2000);
    }
  };
  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    toast.success("Invite link copied!");
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <button onClick={share} className="flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-espresso text-cream font-semibold hover:bg-espressoDeep transition active:scale-95" data-testid="share-button">
        <Share2 size={18} /> {label}
      </button>
      <button onClick={copy} className="flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-hair bg-white text-espresso font-semibold hover:border-gold transition active:scale-95" data-testid="copy-link-button">
        {copied ? <Check size={18} className="text-gold" /> : <Copy size={18} />} Copy Invite Link
      </button>
    </div>
  );
}
